export default __webpack_public_path__ + "6a2abfec61efcb91a0dfce241f90b8b2.png";